import React from "react";
import PropTypes from "prop-types";
import styles from "./message.module.scss";

const Message = ({ text }) => {
  return (
    <div className={styles.message}>
      <div className={styles.content}>{text}</div>
    </div>
  );
};

Message.propTypes = {
  text: PropTypes.string,
};

Message.defaultProps = {
  text: "",
};

export default Message;
